<button
  class="flex h-12 w-12 items-center justify-center rounded-full bg-states-white text-center text-text-black shadow-button-primary"
  (click)="onButtonClick()"
>
  <svg-icon [key]="iconKey()" />
</button>
